module.exports = __webpack_public_path__ + "img/checklist.6f08aae1.jpg";